import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import {
  LoadSecondary,
  TransportOrderPrimary,
} from '../../../../store/state/monitoring/transport/models/transport-list.model';
import { UNKNOWN } from '../../../../common/constants/template.constant';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { ShipmentFilterType } from '../../../../store/models';
import { MonitoringPageType } from '../../../../store/state/monitoring/constants';
import { DeviationType, DateType } from '../../../../store';
import { DirectivesModule } from '../../../../common/directives/directives.module';
import { PipesModule } from '../../../../common/pipes/pipes.module';
import { DeviationTypeComponent } from '../../../deviation-type';
import { DatesComponent } from '../../dates/dates.component';
import { LoadInfoBarComponent } from '../../../load-info-bar/load-info-bar.component';
import { LoadInfoBarHeaderDatesComponent } from '../../../load-info-bar/load-info-bar-header-dates/load-info-bar-header-dates.component';
@Component({
  selector: 'ui-transport-order-card',
  imports: [
    CommonModule,
    RouterModule,
    MatCardModule,
    MatExpansionModule,
    TranslateModule,
    DirectivesModule,
    PipesModule,
    DeviationTypeComponent,
    DatesComponent,
    LoadInfoBarComponent,
    LoadInfoBarHeaderDatesComponent,
  ],
  templateUrl: './transport-order-card.component.html',
  styleUrls: ['./transport-order-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransportOrderCardComponent {
  @Input() set transportOrderItem(value: TransportOrderPrimary) {
    this.transportOrder = value;

    this.hasLabel = value.loads.some(
      ({ deviation: { deviationType }, isCancelled }: LoadSecondary) =>
        deviationType === ShipmentFilterType.Early || deviationType === ShipmentFilterType.Delay || isCancelled,
    );

    this.hasSpeedUpInfo = value.loads.some(({ speedUpInformation }: LoadSecondary) => Boolean(speedUpInformation));
  }
  @Input() monitoringPageType: MonitoringPageType;

  unknown = UNKNOWN;
  transportMode = TransportMode;
  deviationType = DeviationType;
  dateType = DateType;
  transportOrder: TransportOrderPrimary;
  hasLabel: boolean;
  hasSpeedUpInfo: boolean;
}
